import { Env } from "./ConfigInterface";

export type FeatureFlagType = {
    enableDefaultTileAppFeature: boolean;
    enableJQLIntegration: boolean;
    enableNextThinkIntegration: boolean;
    enableOrderIt: boolean;
};

const featureFlagConfig: Record<Env, FeatureFlagType> = {
    local: {
        enableDefaultTileAppFeature: true,
        enableJQLIntegration: true,
        enableNextThinkIntegration: true,
        enableOrderIt: true,
    },
    dev: {
        enableDefaultTileAppFeature: true,
        enableJQLIntegration: false,
        enableNextThinkIntegration: false,
        enableOrderIt: true,
    },
    qa: {
        enableDefaultTileAppFeature: true,
        enableJQLIntegration: false,
        enableNextThinkIntegration: false,
        enableOrderIt: false,
    },
    pp: {
        enableDefaultTileAppFeature: true,
        enableJQLIntegration: false,
        enableNextThinkIntegration: false,
        enableOrderIt: false,
    },
    prod: {
        enableDefaultTileAppFeature: true,
        enableJQLIntegration: false,
        enableNextThinkIntegration: false,
        enableOrderIt: false,
    },
};

export default featureFlagConfig;
